import 'shared/api/instance';
import 'normalize.css/normalize.css';
import 'app/styles/main.scss';
import 'reflect-metadata';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { BaseLayout } from './app/layouts/BaseLayout/BaseLayout';
import { AppProviders } from './app/providers';
import { ApiInterceptorProvider } from './app/providers/ApiInterceptorContext';
import PaymentSuccessRedirect from './entities/order/ui/PaymentSuccessRedirect';
import { AppErrorFallbackPage } from './pages/AppErrorFallbackPage/AppErrorFallbackPage';
import { CallbackYandexPage } from './pages/CallbackYandexPage/CallbackYandexPage';
import { HomePage } from './pages/Home';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
import { PaymentFailPage } from './pages/PaymentFailPage/PaymentFailPage';
import { RestaurantPage } from './pages/RestaurantPage/RestaurantPage';

import { LegalPage } from '@/pages/LegalPage/LegalPage';
import { ROUTES } from '@/shared/constants/routes';

dayjs.extend(utc);

const root = document.getElementById('root')!;
ReactDOM.createRoot(root).render(
  <ErrorBoundary FallbackComponent={AppErrorFallbackPage}>
    <AppProviders>
      <ApiInterceptorProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<BaseLayout />}>
              <Route path={ROUTES.home()} element={<HomePage />} />
              <Route
                path={ROUTES.paymentSuccess()}
                element={<PaymentSuccessRedirect />}
              />
              <Route
                path={ROUTES.restaurant(':code')}
                element={<RestaurantPage />}
              />
              <Route
                path={ROUTES.paymentFail()}
                element={<PaymentFailPage />}
              />
              <Route path={ROUTES.legal()} element={<LegalPage />} />
              <Route
                path={ROUTES.yandexCallback()}
                element={<CallbackYandexPage />}
              />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ApiInterceptorProvider>
    </AppProviders>
  </ErrorBoundary>
);
